<script>
export default {
    created() {
        this.$emit('created', this);
    }
}
</script>